import { PropertyType, TaskPriority, TaskStatus } from '@/lib/types/enums';

export const TASK_CATEGORIES = [
  { value: 'handyman', label: 'Handyman' },
  { value: 'landscaping', label: 'Landscaping' },
  { value: 'cleaning', label: 'Cleaning' },
  { value: 'other', label: 'Other' },
] as const;

export const TASK_PRIORITIES = [
  { value: TaskPriority.LOW, label: 'Low' },
  { value: TaskPriority.MEDIUM, label: 'Medium' },
  { value: TaskPriority.HIGH, label: 'High' },
] as const;

export const TASK_STATUS = [
  { value: TaskStatus.PENDING, label: 'Pending' },
  { value: TaskStatus.IN_PROGRESS, label: 'In Progress' },
  { value: TaskStatus.COMPLETED, label: 'Completed' },
  { value: TaskStatus.CANCELLED, label: 'Cancelled' },
] as const;

export const PROPERTY_TYPES = [
  { value: PropertyType.RESIDENTIAL, label: 'Residential' },
  { value: PropertyType.COMMERCIAL, label: 'Commercial' },
  { value: PropertyType.INDUSTRIAL, label: 'Industrial' },
] as const;